import { format } from 'date-fns';
import { es } from 'date-fns/locale';

/**
 * Formato VISIBLE de un timestamp de auditoría: fecha, hora de 12 h con AM/PM y segundos.
 * Ejemplo: "17/09/2026 10:50:45 AM".
 *
 * Nunca tiempo relativo ("hace un minuto"): dos eventos del mismo minuto deben seguir siendo
 * distinguibles, y para eso bastan los SEGUNDOS. Hasta aquí se pintaban además las centésimas
 * (`15:10:23.45`), que no distinguen nada que los segundos no distingan ya y añaden dos dígitos
 * de ruido a cada tarjeta del historial. La precisión no se pierde: sigue entera en el `title`
 * que devuelve `formatAuditTimestampExact`, que es el sitio natural para el dato forense.
 *
 * `a` con el locale `es` de date-fns rinde «AM»/«PM» en mayúsculas (verificado, no asumido).
 */
export function formatAuditTimestamp(isoTimestamp: string): string {
  return format(new Date(isoTimestamp), 'dd/MM/yyyy hh:mm:ss a', { locale: es });
}

/**
 * Formato EXACTO para el `title` (tooltip): todo lo anterior más las centésimas.
 * Ejemplo: "17/09/2026 10:50:45.77 AM".
 *
 * Aquí sí se conservan las centésimas: el tooltip es donde se va a mirar cuando dos entradas
 * caen en el mismo segundo y hay que desempatarlas.
 */
export function formatAuditTimestampExact(isoTimestamp: string): string {
  return format(new Date(isoTimestamp), 'dd/MM/yyyy hh:mm:ss.SS a', { locale: es });
}
